import React from "react";
import { DialogProps } from "@mui/material";
import { AddonCode } from "@growth-machine-llc/stridist-api-client";
import { CBAPreactivationDialog } from "../components/dialog/CBAPreactivationDialog";

export interface ActivationDialogProps extends Omit<DialogProps, "title"> {
  onCancel: () => void;
  onConfirm: () => void;
}

export type AddonCatalogItem = {
  displayName: string;
  description: string;
  unitLabel: string;
  ActivationDialog?: React.ComponentType<ActivationDialogProps>;
};

export const ADDON_CATALOG: Record<AddonCode, AddonCatalogItem> = {
  TEAM_ACCOUNT: {
    displayName: "Team Account",
    description: "Invite additional coaches to collaborate in your workspace.",
    unitLabel: "seat",
  },
  CBA: {
    displayName: "Custom branded apps",
    description:
      "Make your brand front and center! Your clients will not know what Stridist is - fully branded experience.",
    unitLabel: "app",
    ActivationDialog: CBAPreactivationDialog,
  },
};

export type AddonName = keyof typeof ADDON_CATALOG;
